module.exports = __webpack_public_path__ + "static/img/female-bg-es.dbcbbd7f.png";